var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.8vw",
    height: "1.7vw",
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 34,
    rx: 5,
    fill: "#50C878"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 20.0653L24.3057 22.0096L21.3981 19.1019L20.1019 20.3981L23.0096 23.3057L21.0653 25.25H26.25V20.0653ZM9.75 13.9347L11.6942 11.9904L14.6019 14.8981L15.8981 13.6019L12.9904 10.6942L14.9347 8.75H9.75V13.9347ZM26.25 8.75H21.0653L23.0096 10.6942L20.1019 13.6019L21.3981 14.8981L24.3057 11.9904L26.25 13.9347V8.75ZM9.75 25.25H14.9347L12.9904 23.3057L15.8981 20.3981L14.6019 19.1019L11.6942 22.0096L9.75 20.0653V25.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.d9dc77445fd9560579861c08084fb918.svg";
export { ForwardRef as ReactComponent };